import React from "react";
import { SvgProps } from "react-native-svg";
import icons from "./IconYellowBankingList";

export interface BankingIconsProps extends SvgProps {
  size?: string | number;
  name: string;
}

const IconsYellowBanking = (props: BankingIconsProps) => {
  const { size = 24, name = "settings" } = props;
  const Icon: React.FC<SvgProps> = icons[name];

  if (!Icon) {
    return null;
  }
  return <img src={icons[name]} style={{ width: size, height: size }} />;
};

export const bundleAssets = Array(icons);

export default IconsYellowBanking;
